import { useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';
import { useAuth0 } from '@auth0/auth0-react';

// Explicit socket URL takes priority; otherwise derive origin from the API URL
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL
  ?? (process.env.REACT_APP_API_URL
    ? new URL(process.env.REACT_APP_API_URL).origin
    : 'http://localhost:3002');

type EventHandler = (payload: any) => void;

export function useOrgSocket(handlers: Record<string, EventHandler>) {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const socketRef = useRef<Socket | null>(null);
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    if (!isAuthenticated) return;

    let socket: Socket;

    getAccessTokenSilently().then((token) => {
      socket = io(SOCKET_URL, {
        auth: { token },
        transports: ['polling', 'websocket'],
        reconnectionDelay: 2000,
      });

      socketRef.current = socket;

      socket.on('connect', () => console.log('[socket] connected', socket.id));
      socket.on('disconnect', (reason) => console.log('[socket] disconnected', reason));
      socket.on('connect_error', (err) => console.log('[socket] connect_error', err.message));

      Object.keys(handlersRef.current).forEach((event) => {
        socket.on(event, (payload) => {
          console.log('[socket] event:', event, payload);
          handlersRef.current[event]?.(payload);
        });
      });
    }).catch(() => {});

    return () => {
      socket?.disconnect();
      socketRef.current = null;
    };
  }, [isAuthenticated, getAccessTokenSilently]);
}
